import * as React from 'react';
import { MediaPreviewComponent } from '../components/media';

// Exemplo de uso do MediaPreview com Preview Mobile integrado
const MediaPreviewWithMobileExample: React.FC = () => {
  const [file, setFile] = React.useState<any>(null);

  // Simula upload de arquivo
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFile({
          preview: e.target?.result as string,
          uri: e.target?.result as string,
          path: selectedFile.name,
          size: selectedFile.size,
          type: selectedFile.type
        });
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>📱 Exemplo: MediaPreview com Preview Mobile</h1>
      
      <div style={{ marginBottom: '30px' }}>
        <label htmlFor="file-input" style={{
          display: 'inline-block',
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          borderRadius: '5px',
          cursor: 'pointer'
        }}>
          Selecionar Imagem
        </label>
        <input 
          id="file-input"
          type="file" 
          accept="image/*" 
          onChange={handleFileSelect}
          style={{ display: 'none' }}
        />
      </div>

      {file && (
        <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '20px' }}>
          <h3>Preview da Imagem:</h3>
          <MediaPreviewComponent
            file={file}
            mediaType="image"
            removeAll={() => setFile(null)}
            isUploading={false}
            uploadProgress={0}
            title="Meu Curso Incrível"
            description="Este é um curso fantástico que vai transformar sua vida fitness!"
          />
        </div>
      )}

      {!file && (
        <div style={{
          border: '2px dashed #ddd',
          borderRadius: '8px',
          padding: '40px',
          textAlign: 'center',
          color: '#666'
        }}>
          <p>👆 Selecione uma imagem para ver o preview mobile estilo Netflix!</p>
          <p><small>O botão "Ver Preview Mobile" abrirá um modal sem submeter nada</small></p>
        </div>
      )}

      <div style={{ 
        marginTop: '40px',
        padding: '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px'
      }}>
        <h3>✨ Funcionalidades do Modal:</h3>
        <ul>
          <li>🖼️ Preview automático para imagens (frontend only)</li>
          <li>📱 Modal responsivo simulando dispositivo móvel</li>
          <li>🎛️ 3 modos: Poster (2:3), Cover (16:9), Ambos</li>
          <li>🎨 Design estilo Netflix com animações</li>
          <li>⌨️ Fecha com ESC, X ou clique fora do modal</li>
          <li>🚫 Sem submit - apenas visualização</li>
          <li>👀 Sua imagem destacada com outros cursos de exemplo</li>
          <li>🔒 Bloqueia scroll da página quando aberto</li>
        </ul>
      </div>
    </div>
  );
};

export default MediaPreviewWithMobileExample;
